import { Component, OnInit, inject } from '@angular/core';
import { CourseModel, CourseQuery } from 'src/app/api/models';
import { AccessRequestsService, CoursesService } from 'src/app/api/services';
import { getCourseListConfig } from 'src/app/cms/list/course-list.component';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import {
  COURSE_TOUR_STEPS,
  showCourseTour,
} from '../../onboarding/course-tour';
import { TourTrackType } from '../../onboarding/guided-tour';
import { SubscriptionLimit } from 'src/app/cms/common/dialogs/subscription-limit-warning/subscription-limit-warning.component';
import {
  DashboardCardBaseComponent,
  getSteps,
  ProgressBarData,
  ProgressStep,
} from '../dashboard-card-base.component';
import { ListConfig } from 'src/app/cms/list/list.types';
import { AuthService } from 'src/app/auth/auth.service';
import { NgTemplateOutlet } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { ProgressStatusBarComponent } from '../progress-dialog/progress-status-bar/progress-status-bar.component';

@Component({
  selector: 'qa-course-card',
  templateUrl: './course-card.component.html',
  styleUrls: ['./course-card.component.scss'],
  imports: [
    MatCard,
    RouterLink,
    MatIcon,
    ButtonComponent,
    TranslateModule,
    NgTemplateOutlet,
    MatTooltip,
    ProgressStatusBarComponent,
  ],
})
export class CourseCardComponent
  extends DashboardCardBaseComponent<CourseModel>
  implements OnInit
{
  courseConfig: ListConfig<CourseModel>;
  steps: ProgressStep[];
  progress: ProgressBarData;
  cardType = TourTrackType.COURSE;

  private coursesService = inject(CoursesService);
  private auth = inject(AuthService);
  private accessRequestsService = inject(AccessRequestsService);

  ngOnInit(): void {
    this.coursesService
      .queryCourses({
        body: {
          filters: {},
          sorting: [
            {
              option: 'created_at',
              direction: 'DESC',
            },
          ],
          paging: {
            page_size: 4,
          },
        } as Partial<CourseQuery> as CourseQuery,
      })
      .subscribe((res) => {
        this.items = res.data;
        this.totalItems = res.pagination.total;
        this.subscriptionLimit.subscriptionLimit.COURSE_COUNT =
          res.pagination.total;
        this.isLoaded = true;
      });
    this.courseConfig = getCourseListConfig(
      this.coursesService,
      this.matDialog,
      this.router,
      this.dialog,
      this.translator,
      true,
      [],
      this.panelService,
      this.snackBar,
      this.auth,
      this.accessRequestsService,
      this.editService,
      this.subscriptionLimit,
      this.trackingService
    );
    const data = getSteps(TourTrackType.COURSE, this.userJourney);
    this.steps = data.steps;
    this.progress = data.progressData;
    this.loadPreferences();
  }

  onProgressClick(event: MouseEvent) {
    event.stopPropagation();
    const data = {
      title: 'dashboardNew.progressSection.coursesProgress',
      tourType: TourTrackType.COURSE,
      stepsData: {
        steps: this.steps,
        progressData: this.progress,
      },
    };
    this.openProgressDialog(data);
  }

  openAddContentDialog(event) {
    event.stopPropagation();
    this.openAddContentDialogBase(
      SubscriptionLimit.COURSE_COUNT,
      this.courseConfig.wizardImports,
      'content.wizardActions.title.createCourse'
    );
  }

  openVideo(event) {
    event.stopPropagation();
    this.openVideoBase(TourTrackType.COURSE, 'course');
  }

  openStep(event) {
    event.stopPropagation();
    this.openStepBase(
      TourTrackType.COURSE,
      'https://quizacademy.de/akademie/kurse/'
    );
  }

  onGuidedTour(event) {
    event.stopPropagation();
    showCourseTour(
      this.injector,
      COURSE_TOUR_STEPS.START_TOUR,
      this.items.length ? null : COURSE_TOUR_STEPS.CLICK_ON_ADD
    );
  }
}
